<template>
<component
  :is="col.type"
  :row="row"
  :data="row[col.colId]"
  :col="col"
  @click="clickHandler"
/>
</template>

<script>
import Link from './Link';
import Status from './Status';
import LineBreakText from './LineBreakText';
import Operation from './Operation.vue';
import Radio from './RadioCustom.vue';

export default {
  name: 'Column',
  components: {
    Link,
    Status,
    LineBreakText,
    Operation,
    Radio
  },
  props: ['col', 'row'],
  methods: {
    clickHandler (data) {
      data.colId = this.col.colId;
      this.$emit('click', data);
    },
  },
};
</script>
